import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/foot-watch/$diaryId/_view/history')({
    component: () => <div>Hello /_app/foot-watch/$diaryId/history!</div>,
});
